import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleRight } from '@fortawesome/free-solid-svg-icons';

import FluidImg from 'Components/Utility/FluidImg';
import PriceContainer from 'Containers/Utility/Price/PriceContainer';

import 'Components/Product/ProductOffers/PartOfBundle.scss';
import 'Components/Cards/FreeProductCard.scss';

const PartOfBundle = ({
  partOfBundle,
  productName,
}) => {
  let fullPrice = partOfBundle.fullPriceFixed;
  if (partOfBundle.is_srp_bundle) {
    const srpPrice = {};
    Object.keys(partOfBundle.price).forEach((key) => {
      srpPrice[key] = partOfBundle.price[key] / 100;
    });
    fullPrice = srpPrice;
  }

  return (
    <div className="part-of-bundle-container">
      <div className="part-of-bundle-header">
        {partOfBundle.type === 'bundle' && partOfBundle.displayTotal > 0 &&
          <FormattedMessage
            id="partofbundle.productnamemessagetiered"
            defaultMessage="Buy {productName} and {displayTotal} {displayTotal, plural, one { other item in:} other {other items in:}}"
            values={{
              productName,
              displayTotal: (partOfBundle.displayTotal - 1),
            }}
          />
        }

        {!partOfBundle.displayTotal &&
          <FormattedMessage
            id="partofbundle.productnamemessage"
            defaultMessage="Buy {productName} in:"
            values={{
              productName,
            }}
          />
        }
      </div>

      <Link
        to={`/${partOfBundle.type}/${partOfBundle.slug}`}
        style={{
          width: '100%',
        }}
      >
        <div className="part-of-bundle-game">
          <div className="part-of-bundle-game-image">
            <FluidImg
              src={partOfBundle.cover}
              alt={partOfBundle.name}
              subfolder="original"
              className="w-100"
            />
          </div>
          <div className="part-of-bundle-game-text-price">
            <div className="part-of-bundle-game-text">
              {partOfBundle.name}
            </div>
            <div className="part-of-bundle-game-price">
              {partOfBundle.type !== 'pick-and-mix' &&
                <PriceContainer
                  discountPercent={partOfBundle.discount_percent}
                  price={partOfBundle.priceFixed}
                  tiered={partOfBundle.tiered}
                  hideDiscount={partOfBundle.hide_discount}
                  slug={partOfBundle.slug}
                  type={partOfBundle.type}
                  fullPrice={fullPrice}
                  payWhatYouWant={partOfBundle.pay_what_you_want}
                  isSrpBundle={partOfBundle.is_srp_bundle}
                />
              }

              {partOfBundle.type === 'pick-and-mix' &&
                <React.Fragment>
                  {partOfBundle.percentageBased ?
                    <FormattedMessage
                      id="partOfBundle.promotion-banner.percentagediscount"
                      defaultMessage="{percent}% off"
                      values={{
                        percent: partOfBundle.pickAndMixPercent,
                      }}
                    />
                    :
                    <PriceContainer
                      tiered
                      price={partOfBundle.pickAndMixPrice}
                      slug={partOfBundle.slug}
                      type={partOfBundle.type}
                    />
                  }
                </React.Fragment>
              }
            </div>
          </div>

          <div className="part-of-bundle-game-button">
            <FontAwesomeIcon icon={faCircleRight} />
            <FormattedMessage
              id="partofbundle.button.view"
              defaultMessage="View"
            />
          </div>

        </div>
      </Link>
    </div>
  );
};

PartOfBundle.propTypes = {
  partOfBundle: PropTypes.shape({}),
  productName: PropTypes.string,
};

PartOfBundle.defaultProps = {
  partOfBundle: {},
  productName: '',
};

export default PartOfBundle;
